import {
  FETCH_VARIABLES_REQUEST,
  FETCH_VARIABLES_SUCCEEDED,
  FETCH_VARIABLES_FAILED,
  CREATE_VARIABLES_REQUEST,
  CREATE_VARIABLES_SUCCEEDED,
  CREATE_VARIABLES_FAILED,
  UPDATE_VARIABLES_REQUEST,
  UPDATE_VARIABLES_SUCCEEDED,
  UPDATE_VARIABLES_FAILED,
  DELETE_VARIABLES_REQUEST,
  DELETE_VARIABLES_SUCCEEDED,
  DELETE_VARIABLES_FAILED,
  INVALIDATE_VARIABLE_MAPPINGS,
  INVALIDATE_VARIABLES
} from 'constants/actionTypes';

import _ from 'lodash'

const initialState = {
    loading: false,
    fetched: false,
    creating: false,
    deleting: false,
    deleted: false,
    updating: false,
    invalidated: true,
    items: [],
    pagination: {
      currentPage: 0,
      totalPages: 0,
      recordsPerPage: 10,
      totalRecordsCount: 0,
    },
}


export function variableReducer(state = initialState, action) {
  switch(action.type) {
    case FETCH_VARIABLES_REQUEST: {
      return {
        ...state,
        loading: true
      }
    }

    case FETCH_VARIABLES_SUCCEEDED: {
      const { response } = action.payload;
      let items = [];

      if (response.currentPage !== 0) {
        items = [...state.items, ...response.records];
      } else {
        items = response.records;
      }

      items = _.uniqBy(items, 'id');

      return {
        ...state,
        loading: false,
        items: items,
        pagination: {
          currentPage: response.currentPage,
          totalPages: response.totalPages,
          recordsPerPage: response.recordsPerPage,
          totalRecordsCount: response.totalRecordsCount,
        },
      }
    }

    case FETCH_VARIABLES_FAILED: {
      const { error } = action.payload;

      return {
        ...state,
        loading: false,
        error: error
      }
    }

    case CREATE_VARIABLES_REQUEST: {
      return {
        ...state,
        creating: true
      }
    }

    case CREATE_VARIABLES_SUCCEEDED: {
      const { response } = action.payload;
      let items = _.get(state, 'items', []);

      return {
        ...state,
        creating: false,
        items: [response, ...items],
      }
    }

    case CREATE_VARIABLES_FAILED: {
      const { error } = action.payload;

      return {
        ...state,
        creating: false,
        error: error
      }
    }

    case UPDATE_VARIABLES_REQUEST: {
      return {
        ...state,
        updating: true
      }
    }

    case UPDATE_VARIABLES_SUCCEEDED: {
      const { response } = action.payload;

      let items = _.get(state, 'items', []);
    
      const updatedItems = items.map((item) => {
        if (item.id === response.id) {
          return {
            ...item,
            name: response.name,
            defaultValue: response.defaultValue,
            modifiedDate: response.modifiedDate, // Optional: update modified timestamp too
          };
        }
        return item;
      });

      return {
        ...state,
        updating: false,
        items: updatedItems
      }
    }

    case UPDATE_VARIABLES_FAILED: {
      const { error } = action.payload;

      return {
        ...state,
        updating: false,
        error: error
      }
    }


    case DELETE_VARIABLES_REQUEST: {
      return {
        ...state,
        deleting: true
      }
    }

    case DELETE_VARIABLES_SUCCEEDED: {
      const { response, pageId } = action.payload;

      let items = _.get(state, 'items', []);
    
      const updatedVaribales = items.filter(item => item.id !== response.id);

      return {
        ...state,
        deleting: false,
        deleted: true,
        items: updatedVaribales
      }
    }

    case DELETE_VARIABLES_FAILED: {
      const { error } = action.payload;

      return {
        ...state,
        deleting: false,
        error: error
      }
    }

    case INVALIDATE_VARIABLE_MAPPINGS: {
      return {
        ...state,
        invalidated: true,
        fetched: false,
        creating: false,
        deleting: false,
        deleted: false,
        updating: false,
      }
    }

    case INVALIDATE_VARIABLES: {
      return initialState
    }

    default:
      return state;
  }
}